module.exports = __webpack_public_path__ + "static/img/Mini Bags.f72a3c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mini Bags.jpg
// module id = 06mX
// module chunks = 1